@if (visitorIdentificationTimestamp$ | async; as timestamp) {
  @if (timestamp) {
    <meta name="VIcurrentDateTime" [content]="timestamp" />
  }
}
